import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';

import equal from 'deep-equal';

import { blank, dig } from 'spiceutils';

import { makeSelectRespondToBreakGroupChange } from 'containers/App/selectors';

import BreakGroup from './BreakGroup';
import BreakAnswer from './BreakAnswer';

class BreakGroupAnswer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      groupValue: dig(props, ['cdf', 'BreakGroup']) || '',
      answerValue: dig(props, ['cdf', 'BreakAnswer']) || '',
    };
  }
  componentWillReceiveProps(newProps) {
    if (!equal(this.props, newProps)) {
      const newState = {};

      if (newProps.cdf.BreakGroup !== this.props.cdf.BreakGroup) {
        if (newProps.cdf.BreakGroup !== this.state.groupValue) {
          newState.groupValue = newProps.cdf.BreakGroup || '';
        }
      }
      if (newProps.cdf.BreakAnswer !== this.props.cdf.BreakAnswer) {
        if (newProps.cdf.BreakAnswer !== this.state.answerValue) {
          newState.answerValue = newProps.cdf.BreakAnswer || '';
        }
      }

      if (!blank(newState)) {
        this.setState(newState);
      }
    }
  }
  onChange(breakGroup, breakAnswer) {
    const {
      updateCDF,
      respondToBreakGroupChange,
    } = this.props;

    if (breakGroup && (respondToBreakGroupChange || breakAnswer)) {
      updateCDF([
        { field: 'BreakGroup', value: breakGroup },
        { field: 'BreakAnswer', value: breakAnswer },
      ]);
    } else {
      updateCDF([
        { field: 'BreakGroup', value: null },
        { field: 'BreakAnswer', value: null },
      ]);
    }

    this.setState({
      groupValue: breakGroup || '',
      answerValue: breakAnswer || '',
    });
  }
  groupChange(val) {
    this.onChange(val, null);
  }
  answerChange(val) {
    const { groupValue } = this.state;
    this.onChange(groupValue, val);
  }
  render() {
    if (dig(this.props.controlList, ['BreakGroup', 'Visible']) === true) {
      let breakAnswer = null;
      if (this.state.groupValue.length > 0) {
        breakAnswer = (
          <BreakAnswer controlList={this.props.controlList.BreakAnswer} cdf={this.props.cdf} onChange={(val) => this.answerChange(val)} value={this.state.answerValue} breakGroup={this.state.groupValue} />
        );
      }
      return (
        <div>
          <BreakGroup controlList={this.props.controlList.BreakGroup} cdf={this.props.cdf} onChange={(e) => this.groupChange(e)} value={this.state.groupValue} />
          {breakAnswer}
        </div>
      );
    }
    return null;
  }
}

BreakGroupAnswer.propTypes = {
  cdf: PropTypes.object,
  controlList: PropTypes.object,
  updateCDF: PropTypes.func,
  respondToBreakGroupChange: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  respondToBreakGroupChange: makeSelectRespondToBreakGroupChange(),
});

const mapDispatchToProps = (/* dispatch */) => ({
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withConnect
)(BreakGroupAnswer);



// WEBPACK FOOTER //
// ./app/components/FormControls/BreakGroup_BreakAnswer/index.js